import { render, staticRenderFns } from "./ExportLocalization.vue?vue&type=template&id=356d518c"
import script from "./ExportLocalization.vue?vue&type=script&lang=ts"
export * from "./ExportLocalization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports